import { Box, Button, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { StyledTableCell, StyledTableRow } from '../../ui-components/StyledTables'
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useJobContext } from '../../hooks/Jobs';
import { useAuthContext } from '../../hooks/Auth';
import { useNavigate } from 'react-router-dom';


export const TablaSeguimientoPlanificaciones = () => {

    const {
        jobs,
        wsProject,
        tipoEstructura,
        isCompleted,
        isFailed,
        isProcessing,
        handleStartJob,
        propuestaUsuario,
        handleProyectRecovery,                
        etapa
    } = useJobContext();
    const navigate = useNavigate();

    const { isUserCreditLimit } = useAuthContext();

    const handleResendProyect = () => {
        handleStartJob(propuestaUsuario, etapa, 'crear_proyecto');
    };

    const handleRecovery = () => {        
        handleProyectRecovery(wsProject, etapa, tipoEstructura);                
        switch (tipoEstructura) {
            case 'unidad_activa':   
                navigate("/asistente/unidadtematica");
                break;
            case 'aprendizaje_basado_en_proyectos':     
                navigate("/asistente/abp");
                break;
        }        
    };

    return (
        <>
            <Box sx={{ textAlign: 'center', mt: 2 }}>
                <Typography variant='h4' fontFamily={'Montserrat'} fontWeight={'Bold'} color={'#336B87'}>
                    Seguimiento de recurso en proceso
                </Typography>
            </Box>
            <TableContainer sx={{ width: '100%', margin: 'auto', mt: 6, overflow: 'hidden' }}>
                <Table sx={{ minWidth: 500 }} aria-label="simple table">
                    <TableHead sx={{ height: 20 }}>
                        <TableRow>
                            <StyledTableCell align="left">Tema</StyledTableCell>
                            <StyledTableCell align="left">Etapa</StyledTableCell>
                            <StyledTableCell align="left">Status</StyledTableCell>
                            <StyledTableCell align="left">Acciones</StyledTableCell>                            
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <StyledTableRow key={jobs.title}>
                            <StyledTableCell align="left">{jobs.title}</StyledTableCell>
                            <StyledTableCell align="left">{jobs.etapa}</StyledTableCell>
                            <StyledTableCell align="left">{jobs.status}</StyledTableCell>
                            <StyledTableCell align="left">
                                {isProcessing && !isCompleted && (
                                    <Button sx={{ color: '#336B87' }}>
                                        <HourglassTopIcon />
                                    </Button>
                                )}

                                {isCompleted && !isProcessing && (
                                    <Button
                                        disabled={isUserCreditLimit}
                                        sx={{ color: '#336B87' }}
                                        onClick={() => handleRecovery()}
                                    >
                                        <VisibilityIcon />
                                    </Button>
                                )}
                                {isFailed && (
                                    <Button
                                        disabled={isUserCreditLimit}
                                        variant="contained"
                                        onClick={handleResendProyect}
                                    >
                                        Reenviar
                                    </Button>
                                )}
                            </StyledTableCell>                            
                        </StyledTableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}
